import ApplicationLink from './ApplicationLink';
import AppstorDownloadImg from '../../../assets/appstore_download.png';
import {
  LINK_TO_APPSTORE,
  LINK_TO_GOOGLE_PLAY,
  SUNRISE_LINK_TO_APPSTORE,
  SUNRISE_LINK_TO_GOOGLE_PLAY,
} from '../../../pages/Landing/LnMenHealth/constants';
import GoogleplayDownloadImg from '../../../assets/googleplay_download.png';
import React from 'react';
import styled from 'styled-components';
import Separator from '../../Separator';

const AppLinks = styled.div`
  display: flex;
`;

export const AppLnk = styled.div`
  border-radius: 40px;
  overflow: hidden;
  margin: auto;
  border: 1.4px solid white;
  background-color: ${(props) => props.theme.colors.regent};
  max-width: 160px;
  max-height: 50px;
`;

const AppStoreLink: React.FunctionComponent<{ platform?: string }> = ({ platform = 'MENHEALTH' }) => {
  const link = platform === 'SUNRISE' ? SUNRISE_LINK_TO_APPSTORE : LINK_TO_APPSTORE;
  return (
    <AppLnk>
      <ApplicationLink
        src={AppstorDownloadImg}
        alt={'Download app for ios'}
        link={link}
      />
    </AppLnk>
  );
};

const GooglePlayAppLink: React.FunctionComponent<{ platform?: string }> = ({ platform = 'MENHEALTH' }) => {
  const link = platform === 'SUNRISE' ? SUNRISE_LINK_TO_GOOGLE_PLAY : LINK_TO_GOOGLE_PLAY;
  return (
    <AppLnk>
      <ApplicationLink
        src={GoogleplayDownloadImg}
        alt={'Download app for android'}
        link={link}
      />
    </AppLnk>
  );
};

const ApplicationLinks: React.FunctionComponent<{ platform?: string }> = ({ platform = 'MENHEALTH' }) => {
  return (
    <AppLinks>
      <GooglePlayAppLink platform={platform} />
      <Separator />
      <AppStoreLink platform={platform} />
    </AppLinks>
  );
};

export default ApplicationLinks;
export { AppStoreLink, GooglePlayAppLink };
